import EzUtils from "@/utils/EzUtils";
import storageUtil from "@/utils/StorageUtil";

const PARTNER_APP_PARAM = "PARTNER_APP_PARAM";

export default {
  clearPartnerAppData() {
    storageUtil.removeItem(PARTNER_APP_PARAM);
  },

  setPartnerAppData(partnerAppData) {
    storageUtil.setItem(PARTNER_APP_PARAM, JSON.stringify(partnerAppData));
  },

  getPartnerAppData() {
    const partnerAppData = EzUtils.convertToJSONObjectIfString(
      storageUtil.getItem(PARTNER_APP_PARAM)
    );
    return partnerAppData ? partnerAppData : {};
  },

  setPartnerAppCallback(partnerCallback) {
    let partnerAppData = this.getPartnerAppData();
    partnerAppData.partnerCallback = partnerCallback;
    this.setPartnerAppData(partnerAppData);
  },

  isPartnerAppCallback() {
    let partnerAppData = this.getPartnerAppData();
    return partnerAppData.partnerCallback;
  },

  setPartnerCallbackWithJavaScriptInterface(partnerCallbackWithJavaScriptInterface) {
    let partnerAppData = this.getPartnerAppData();
    partnerAppData.partnerCallbackWithJavaScriptInterface = partnerCallbackWithJavaScriptInterface;
    this.setPartnerAppData(partnerAppData);
  },

  isPartnerCallbackWithJavaScriptInterface() {
    let partnerAppData = this.getPartnerAppData();
    return partnerAppData.partnerCallbackWithJavaScriptInterface;
  }

};
